import { atom } from "recoil";

type fromToDate = {
  from: Date;
  to: Date;
};
export const getEndOfMonth = (date: Date) => {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};
export const getStartOfMonth = (date: Date) => {
  return new Date(date.getFullYear(), date.getMonth() - 0, 1);
};
export const fromToDateState = atom<fromToDate>({
  key: "dateState",
  default: {
    from: getStartOfMonth(new Date()),
    to: getEndOfMonth(new Date()),
  },
});
